import { render, staticRenderFns } from "./ProjectsMore.vue?vue&type=template&id=7f925b12&"
import script from "./ProjectsMore.vue?vue&type=script&lang=js&"
export * from "./ProjectsMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports